export default __webpack_public_path__ + "static/media/ceramic.a1711ee2.png";